module.exports = __webpack_public_path__ + "img/insta-icon.6c9e4469.svg";